(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuvarre-animated-offer"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nuvarre-offer')) {
 customElements.define('nuvarre-offer', class extends HTMLElement {
  connectedCallback() {
   const button=this.querySelector('[data-copy-code]');
   this.copy=async()=>{
    const status=this.querySelector('[data-copy-status]');
    try {
     await navigator.clipboard.writeText(button.dataset.copyCode);
     status.textContent=button.dataset.copied;
     const original=button.textContent;
     button.textContent=button.dataset.copied;
     clearTimeout(this.timer);
     this.timer=setTimeout(()=>{button.textContent=original},2200);
    } catch {status.textContent=button.dataset.fallback}
   };
   button.addEventListener('click',this.copy);
  }
  disconnectedCallback(){this.querySelector('[data-copy-code]')?.removeEventListener('click',this.copy);clearTimeout(this.timer)}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuvarre-go-home"] && !Shopify.designMode) return;
  try {
    
function initGoFilms(root) {
  root.querySelectorAll('[data-go-film]').forEach(video => {
    if (video.dataset.initialized) return;
    video.dataset.initialized = 'true';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          video.muted = true;
          video.play().catch(() => {});
          observer.unobserve(video);
        }
      });
    }, { threshold: 0.3 });
    observer.observe(video);
  });
}
initGoFilms(document);
document.addEventListener('shopify:section:load', event => initGoFilms(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuvarre-marquee"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nuvarre-marquee')){customElements.define('nuvarre-marquee',class extends HTMLElement{connectedCallback(){if(this.bound)return;this.bound=true;const b=this.querySelector('button');b.addEventListener('click',()=>{const paused=this.classList.toggle('is-paused');b.setAttribute('aria-pressed',String(paused));b.setAttribute('aria-label',paused?b.dataset.play:b.dataset.pause);b.querySelector('span').textContent=paused?'▶':'Ⅱ'})}})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuvarre-studio-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nuvarre-motion')) {
 customElements.define('nuvarre-motion', class extends HTMLElement {
  connectedCallback() {
   this.main = document.querySelector('product-info[data-product-id="' + this.dataset.productId + '"]');
   if (!this.main) return;
   this.bar = this.querySelector('.nv-purchase-bar');
   this.buy = this.querySelector('[data-nv-buy]');
   this.variants = JSON.parse(this.querySelector('[data-nv-variants]').textContent);
   this.sync = () => {
    const native = this.main.querySelector('[id^="ProductSubmitButton-"]');
    const input = this.main.querySelector('form[action*="/cart/add"] input[name="id"]');
    const variant = this.variants.find(v => String(v.id) === input?.value);
    if (variant) this.querySelector('[data-nv-variant]').textContent = variant.title;
    const price = this.main.querySelector('[id^="price-"]');
    const amount = price?.querySelector('.price--on-sale .price__sale .price-item--sale') || price?.querySelector('.price__regular .price-item--regular');
    if (amount) this.querySelector('[data-nv-price]').textContent = amount.textContent.trim();
    this.buy.disabled = !native || native.disabled;
    if (native) this.buy.textContent = native.querySelector('span')?.textContent.trim() || native.textContent.trim();
   };
   this.handleBuy = () => {
    const native = this.main.querySelector('[id^="ProductSubmitButton-"]');
    if (native && !native.disabled) native.click();
   };
   this.buy.addEventListener('click', this.handleBuy);
   this.updateObserver = new MutationObserver(this.sync);
   const info = this.main.querySelector('.product__info-container');
   if (info) this.updateObserver.observe(info, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['disabled']});
   this.sync();
   this.media = matchMedia('(max-width:749px)');
   const native = this.main.querySelector('[id^="ProductSubmitButton-"]');
   this.toggleBar = () => {
    const show = this.media.matches && native && native.getBoundingClientRect().bottom < 0;
    this.bar.hidden = !show;
    document.body.classList.toggle('nv-bar-open', Boolean(show));
   };
   this.buyObserver = new IntersectionObserver(this.toggleBar, {threshold:0});
   if (native) this.buyObserver.observe(native);
   this.media.addEventListener('change', this.toggleBar);
   this.toggleBar();
   if (!matchMedia('(prefers-reduced-motion:reduce)').matches) {
    this.revealObserver = new IntersectionObserver(entries => {
     entries.forEach(entry => {
      if (entry.isIntersecting) {
       entry.target.classList.remove('nv-pending');
       this.revealObserver.unobserve(entry.target);
      }
     });
    }, {threshold:.08});
    this.querySelectorAll('.nv-studio__video-row,.nv-studio__details,.nv-studio__sizes,.nv-studio__faq').forEach(el => {
     el.classList.add('nv-reveal');
     if (el.getBoundingClientRect().top > innerHeight) el.classList.add('nv-pending');
     this.revealObserver.observe(el);
    });
   }
  }
  disconnectedCallback() {
   this.updateObserver?.disconnect();
   this.buyObserver?.disconnect();
   this.revealObserver?.disconnect();
   this.media?.removeEventListener('change', this.toggleBar);
   this.buy?.removeEventListener('click', this.handleBuy);
   document.body.classList.remove('nv-bar-open');
  }
 });
}

  } catch(e) { console.error(e); }
})();
})();
